module.exports = __webpack_public_path__ + "b2de366efbacb1d8c2fa2bcb903f5e90.png";